import { MapEditorPlannerAreaPanel_VisitListItemFragment } from "./fragments.generated";

type ItemGroup = {
    id: string;
    name: string;
    items: MapEditorPlannerAreaPanel_VisitListItemFragment[];
};

export default function groupVisitsByProtocol(visits: MapEditorPlannerAreaPanel_VisitListItemFragment[]): ItemGroup[] {
    const groups = new Map<string, ItemGroup>(); // key: observation.type.id (uuid)

    visits.forEach(visit => {
        const group = groups.get(visit.protocol?.id ?? "no_protocol");
        if (group) {
            group.items.push(visit);
        } else {
            groups.set(visit.protocol?.id ?? "no_protocol", {
                id: visit.protocol?.id ?? "no_protocol",
                name: visit.protocol?.name ?? "no_protocol",
                items: [visit],
            });
        }
    });

    // Observation groups: alphabetical A–Z by name
    return [...groups.values()].sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }));
}
